import { Box, Flex, Text } from '@weareberyl/design-system'
import { Tag } from 'antd'
import UserLink, { User } from '~/components/UserLink'

import {
  useUserSummaryQuery,
  ZoneSummaryQuery_zone_Zone_current_suspension_CurrentZoneSuspension as ZoneCurrentSuspension,
} from '~/gql/generated/graphql'
import useCurrentScheme from '~/hooks/useCurrentScheme'

export const CurrentSuspensionInfo = ({
  author_id,
  notes,
  reason,
}: ZoneCurrentSuspension) => {
  const { currentSchemeId } = useCurrentScheme()
  const { data } = useUserSummaryQuery({
    variables: { id: author_id, schemeId: currentSchemeId ?? '1' },
    pollInterval: 0,
  })

  return (
    <Box>
      <Text>
        Suspended for {<Tag>{reason}</Tag>} by{' '}
        <UserLink
          user={(data && data?.user ? data.user : { id: author_id }) as User}
        />
      </Text>
      {notes && (
        <Flex flexDirection={'row'}>
          <Text variant="large">&ldquo;</Text>
          <Text variant="small" style={{ fontStyle: 'italic' }}>
            {notes}
          </Text>
          <Text variant="large" style={{ paddingLeft: '2px' }}>
            &rdquo;
          </Text>
        </Flex>
      )}
    </Box>
  )
}
